import React from 'react';
import Box from '@nubank/nuds-web/components/Box/Box';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Link from '@nubank/nuds-web/components/Link/Link';
import styled from 'styled-components';

const StyledTypography = styled(Typography)`
  /* stylelint-disable property-no-vendor-prefix, property-no-unknown */
  background: linear-gradient(90deg, rgb(159 45 235 / 100%), rgb(98 0 163 / 100%) );
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

function ClosingBlock() {
  return (
    <Box
      paddingHorizontal={{ xs: '8x', md: '48px', lg: '120px' }}
      marginBottom={{ xs: '94px', md: '116px' }}
      display="flex"
      flexDirection="column"
      alignItems="center"
    >
      <Typography
        intlKey="BENEFITS.PARTNERS.CLOSING.TITLE"
        variant="heading2"
        intlValues={{
          highlight: (
            <StyledTypography
              tag="span"
              intlKey="BENEFITS.PARTNERS.CLOSING.TITLE.HIGHLIGHT_BANK"
              variant="heading2"
              color="primary"
            />),
        }}
        marginBottom="6x"
      />

      <Typography
        intlKey="BEFENITS.PARTNERS.CLOSING.DESCRIPTION"
        marginBottom="6x"
        variant="subtitle1"
        width={{ xs: '100%', md: '312px' }}
        intlValues={{
          strong: (...text) => (
            <Typography
              tag="span"
              variant="subtitle1"
              strong
            >
              {text}
            </Typography>
          ),
        }}
        textAlign="center"
        whiteSpace={{ xs: 'pre-line', md: 'normal' }}
      />

      <Link
        intlKey="BEFENITS.PARTNERS.CLOSING.LINK.TITLE_BANK"
        href="/"
        alt="Conoce todo sobre Nubank"
        variant="action"
      />
    </Box>
  );
}

export default ClosingBlock;
